import { Link } from 'react-router-dom'

import { useIntervalUpdate } from 'core/ui/hooks/useIntervalUpdate'
import useWindowWidth from 'core/ui/hooks/useWindowWidth'

import { intSizes } from 'legacy/styles/screen'

import { type Load } from '../../domain/Load'
import { TenderCardDesktop } from './TenderCardDesktop'
import { TenderCardMobile } from './TenderCardMobile'

export type TenderCardProps = {
  disabled?: boolean
  load: Load
  onAccept?: (load: Load) => void
  onReject?: (load: Load) => void
}

export function TenderCard({ load, ...props }: TenderCardProps) {
  useIntervalUpdate(1000 * 60)
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= intSizes.md

  let Component
  if (isMobile) {
    Component = TenderCardMobile
  } else {
    Component = TenderCardDesktop
  }

  return (
    <Link to={`/portal/tender/${load.id}`}>
      <Component load={load} {...props} />
    </Link>
  )
}
